export const removeComma = (s: string) => {
    const regex = /,/g
    return parseFloat(s.replace(regex, ''))
}
